// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._LqduL1Z0hdGIR4gztlI{display:flex;flex-direction:column;gap:12px;margin:8px 0 16px 0}", "",{"version":3,"sources":["webpack://./src/pages/cp/conversations/components/header/index.module.scss"],"names":[],"mappings":"AAAA,sBACI,YAAA,CACA,qBAAA,CACA,QAAA,CACA,mBAAA","sourcesContent":[".header {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    margin: 8px 0 16px 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": "_LqduL1Z0hdGIR4gztlI"
};
export default ___CSS_LOADER_EXPORT___;
